const CHANGE_DRIVER_DRIVING = 'CHANGE_DRIVER_DRIVING';
const CHANGE_DRIVER_LANGUAGE = 'CHANGE_DRIVER_LANGUAGE';
const CHANGE_DRIVER_TOUR_GUIDANCE = 'CHANGE_DRIVER_TOUR_GUIDANCE';
const CHANGE_DRIVER_CAR_COMFORT_CLEANINESS = 'CHANGE_DRIVER_CAR_COMFORT_CLEANINESS';
const CHANGE_DRIVER_OVERALL_VALUE = 'CHANGE_DRIVER_OVERALL_VALUE';
const CHANGE_DRIVER_RECOMENDATION = 'CHANGE_DRIVER_RECOMENDATION';
const CHANGE_CONTENT = 'CHANGE_CONTENT';
const CHANGE_OTHER_FEEDBACK = 'CHANGE_OTHER_FEEDBACK';
const SEND_FEEDBACK = 'SEND_FEEDBACK';
const SEND_FEEDBACK_SUCCESS = 'SEND_FEEDBACK_SUCCESS';
const SEND_FEEDBACK_FAILED = 'SEND_FEEDBACK_FAILED';
const CLEAR_SURVEY_STATE = 'CLEAR_SURVEY_STATE';

const initialState = () => ({
  rateDriverDriving: -1,
  rateDriverLanguage: -1,
  rateDriverTourGuidance: -1,
  rateCarComfortCleaniness: -1,
  rateOverallValue: -1,
  rateRecommendation: -1,
  content: '',
  otherFeedback: '',
  sent: false,
  sending: false,
  error: null,
});

export default function survey(state = initialState(), action = {}) {
  switch (action.type) {
    case CHANGE_DRIVER_DRIVING:
      return {
        ...state,
        rateDriverDriving: action.data,
      };
    case CHANGE_DRIVER_LANGUAGE:
      return {
        ...state,
        rateDriverLanguage: action.data,
      };
    case CHANGE_DRIVER_TOUR_GUIDANCE:
      return {
        ...state,
        rateDriverTourGuidance: action.data,
      };
    case CHANGE_DRIVER_CAR_COMFORT_CLEANINESS:
      return {
        ...state,
        rateCarComfortCleaniness: action.data,
      };
    case CHANGE_DRIVER_OVERALL_VALUE:
      return {
        ...state,
        rateOverallValue: action.data,
      };
    case CHANGE_DRIVER_RECOMENDATION:
      return {
        ...state,
        rateRecommendation: action.data,
      };
    case CHANGE_CONTENT:
      return {
        ...state,
        content: action.data,
      };
    case CHANGE_OTHER_FEEDBACK:
      return {
        ...state,
        otherFeedback: action.data,
      };
    case SEND_FEEDBACK:
      return {
        ...state,
        sent: false,
        sending: true,
        error: null,
      };
    case SEND_FEEDBACK_SUCCESS:
      return {
        ...state,
        sent: true,
        sending: false,
        error: null,
      };
    case SEND_FEEDBACK_FAILED:
      return {
        ...state,
        sent: false,
        sending: false,
        error: action.error,
      };
    case CLEAR_SURVEY_STATE:
      return initialState();
    default:
      return state;
  }
}

export function changeRateDriverDriving(data) {
  return {
    type: CHANGE_DRIVER_DRIVING,
    data,
  };
}

export function changeRateDriverLanguage(data) {
  return {
    type: CHANGE_DRIVER_LANGUAGE,
    data,
  };
}

export function changeRateDriverTourGuidance(data) {
  return {
    type: CHANGE_DRIVER_TOUR_GUIDANCE,
    data,
  };
}

export function changeRateCarComfortCleaniness(data) {
  return {
    type: CHANGE_DRIVER_CAR_COMFORT_CLEANINESS,
    data,
  };
}

export function changeRateOverallValue(data) {
  return {
    type: CHANGE_DRIVER_OVERALL_VALUE,
    data,
  };
}

export function changeRateRecommendation(data) {
  return {
    type: CHANGE_DRIVER_RECOMENDATION,
    data,
  };
}

export function changeContent(data) {
  return {
    type: CHANGE_CONTENT,
    data,
  };
}

export function changeOtherFeedback(data) {
  return {
    type: CHANGE_OTHER_FEEDBACK,
    data,
  };
}

export function clearSurveyState() {
  return {
    type: CLEAR_SURVEY_STATE,
  };
}

export function sendReview(reference, feedback) {
  return {
    types: [SEND_FEEDBACK, SEND_FEEDBACK_SUCCESS, SEND_FEEDBACK_FAILED],
    promise: ({ client }) => client.post('/booking/review/', {
      data: {
        reference,
        feedback,
      }
    })
  };
}
